var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 56.385,
    viewBox: "0 0 74 56.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subscription",
    transform: "translate(-42 -29.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535",
    transform: "translate(42 29.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M44.846,29.952A2.847,2.847,0,0,0,42,32.8V72.918a2.847,2.847,0,0,0,2.846,2.846H79V29.952Z",
    transform: "translate(-42 -29.952)",
    fill: "#294b6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M89.154,29.952H55V75.764H89.154A2.847,2.847,0,0,0,92,72.918V32.8A2.847,2.847,0,0,0,89.154,29.952Z",
    transform: "translate(-18 -29.952)",
    fill: "#6283a3"
  }), /*#__PURE__*/React.createElement("text", {
    id: "LICENSE",
    transform: "translate(6.251 10.716)",
    fill: "#fff",
    fontSize: 5,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "LICENSE")), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x2: 32.976,
    transform: "translate(3.524 21.144)",
    fill: "aqua",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x2: 23.786,
    transform: "translate(3.524 27.311)",
    fill: "aqua",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x2: 23.786,
    transform: "translate(3.524 32.596)",
    fill: "aqua",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x2: 13.214,
    transform: "translate(3.524 37.882)",
    fill: "aqua",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M64.012,37.381l-5.3,8.81L64,49.714l4.96-9.069Z",
    transform: "translate(-11.143 -16.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M68.615,37.381l5.3,8.81-5.286,3.524-4.96-9.069Z",
    transform: "translate(-2 -16.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M78.153,41.443c0,.273-.717.512-.74.78s.635.64.583.905-.8.37-.871.632.507.743.41.993-.854.219-.973.461.361.823.219,1.053-.879.057-1.042.273.2.877.02,1.076-.871-.105-1.073.077.04.9-.176,1.062-.837-.265-1.067-.12-.125.888-.367,1.01-.774-.413-1.03-.316-.285.854-.546.928-.683-.549-.953-.5-.435.786-.709.808-.572-.666-.845-.666-.578.692-.848.666-.444-.76-.709-.808-.694.575-.953.5-.3-.828-.546-.928-.788.435-1.03.316-.137-.868-.367-1.013-.854.285-1.07.12.026-.877-.176-1.062-.888.125-1.073-.077.185-.86.023-1.076-.9-.04-1.042-.273.342-.808.219-1.053-.874-.2-.973-.458.484-.731.41-1-.823-.361-.871-.629.609-.632.586-.905-.74-.507-.74-.78.714-.515.74-.783-.635-.638-.586-.9.8-.373.871-.632-.507-.743-.41-1,.854-.216.973-.458-.359-.825-.216-1.056.877-.054,1.039-.27-.2-.877-.02-1.076.874.105,1.073-.077-.04-.9.176-1.062.837.262,1.07.12.122-.891.367-1.01.774.413,1.027.313.285-.851.546-.925.686.549.953.5.438-.786.709-.811.572.666.848.666.578-.689.845-.666.444.76.709.811.694-.575.953-.5.3.828.549.925.786-.435,1.027-.313.139.868.367,1.01.854-.282,1.07-.12-.026.879.176,1.062.891-.122,1.073.077-.185.86-.023,1.076.9.043,1.042.273-.339.811-.219,1.053.874.2.973.461-.484.731-.41.993.823.364.871.632-.609.629-.583.9S78.153,41.167,78.153,41.443Z",
    transform: "translate(-9.085 -25.584)",
    fill: "#ff0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536",
    transform: "translate(64.769 70.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M52.246,44.237A2.245,2.245,0,0,0,50,46.483V57.719a2.245,2.245,0,0,0,2.246,2.246H64.231V44.237Z",
    transform: "translate(-50 -44.237)",
    fill: "#003164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M66.985,44.237H55V59.965H66.985a2.245,2.245,0,0,0,2.246-2.246V46.483A2.245,2.245,0,0,0,66.985,44.237Z",
    transform: "translate(-40.769 -44.237)",
    fill: "#003164"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 2.996,
    height: 2.247,
    transform: "translate(1.498 5.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 0.749,
    height: 0.749,
    transform: "translate(1.498 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 0.749,
    height: 0.749,
    transform: "translate(2.996 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 0.749,
    height: 0.749,
    transform: "translate(4.494 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 0.749,
    height: 0.749,
    transform: "translate(5.992 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 0.749,
    height: 0.749,
    transform: "translate(8.239 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 0.749,
    height: 0.749,
    transform: "translate(9.737 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 0.749,
    height: 0.749,
    transform: "translate(11.235 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 0.749,
    height: 0.749,
    transform: "translate(12.733 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 0.749,
    height: 0.749,
    transform: "translate(14.98 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 0.749,
    height: 0.749,
    transform: "translate(16.478 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 0.749,
    height: 0.749,
    transform: "translate(17.976 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 0.749,
    height: 0.749,
    transform: "translate(19.474 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 0.749,
    height: 0.749,
    transform: "translate(21.721 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 0.749,
    height: 0.749,
    transform: "translate(23.219 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 0.749,
    height: 0.749,
    transform: "translate(24.717 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 0.749,
    height: 0.749,
    transform: "translate(26.215 8.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x2: 25.466,
    transform: "translate(1.498 14.23)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x2: 1.498,
    transform: "translate(18.725 1.123)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x2: 1.498,
    transform: "translate(20.972 1.123)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x2: 1.498,
    transform: "translate(23.219 1.123)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 1.498,
    cy: 1.498,
    r: 1.498,
    transform: "translate(21.721 10.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 1.498,
    cy: 1.498,
    r: 1.498,
    transform: "translate(23.968 10.86)",
    fill: "#666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/Subscription.4439a145a7f71b1c4d6a192a9df14b5a.svg";
export { ForwardRef as ReactComponent };